import { useFeatureFlags } from 'apps/wrapper/src/hooks/feature-flags/use-feature-flags';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { useSearch } from 'apps/wrapper/src/hooks/use-search/use-search';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import { SearchDeviceWrapper } from './search-device-wrapper';
import { SearchInput } from './search-input/search-input';
import { SearchResults } from './search-results/search-results';

export interface SearchBarProps {
  visible: boolean;
  onClose: () => void;
}

export const SearchBar: FC<SearchBarProps> = (props) => {
  const { visible, onClose } = props;
  const { selectedLocation } = useLocations();
  const { hasFeature } = useFeatureFlags();

  const { setSearch, setQueryFilter, data } = useSearch();
  const [searchText, setSearchText] = useState('');
  const searchInputRef = useRef<HTMLDivElement>(null);
  const showResults = useMemo(() => searchText.length > 0 && data != null, [searchText, data]);

  useEffect(() => {
    setSearch(searchText);
    if (searchText.length === 0) setQueryFilter({ activePatientsOnly: true, area: 'Location' });
  }, [searchText]);

  useEffect(() => {
    const handleResize = () => setSearchText('');
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!hasFeature(selectedLocation?.id!, 'UniversalSearch')) return null;

  return (
    <SearchDeviceWrapper visible={visible}>
      <SearchInput ref={searchInputRef} value={searchText} onChange={setSearchText} />
      <SearchResults anchorEl={searchInputRef.current} open={showResults} onClose={() => setSearchText('')} />
    </SearchDeviceWrapper>
  );
};
